import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { RouterView } from 'vue-router';
import { useUserStore } from '@/stores/user.ts';
import { ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup (__props) {
        const useInfo = ref();
        watch(()=>useUserStore().user, (value)=>{
            useInfo.value = value;
        }, {
            immediate: true,
            deep: true
        });
        return (_ctx, _cache)=>{
            const _component_van_watermark = _resolveComponent("van-watermark");
            return _openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(RouterView)),
                useInfo.value ? (_openBlock(), _createBlock(_component_van_watermark, {
                    key: 0,
                    content: useInfo.value.nickName + (useInfo.value.userCode || ''),
                    opacity: "0.5",
                    "gap-x": 100,
                    "gap-y": 100
                }, null, 8, [
                    "content"
                ])) : _createCommentVNode("", true)
            ], 64);
        };
    }
});
